import React, { useEffect, useState } from 'react';
import { useWizard } from '../../wizard';
import { StepContainer, RadioGroup, NavigationButtons, InfoBox } from '../index';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const damageChoices = [
  { value: 'intact', label: 'Nej, det er ikke beskadiget' },
  { value: 'unreadable', label: 'Passet indeholder ulæselige stempler/foto/tekst' },
  { value: 'bent', label: 'Passet er bøjet' },
  { value: 'missingPages', label: 'Passet mangler sider' },
  { value: 'worn', label: 'Passet er overdrevet slidt' },
  { value: 'other', label: 'Andet' }
];

const AskPassportDamageStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [title] = useState('Er dit gamle pas beskadiget?');
  const [body, setBody] = useState<string[]>([]);

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.ask_passport_damage).then(c => {
      if (c?.body) {setBody(c.body || []);}
    });
  }, []);

  const handleChange = (value: string) => {
    updateSelfServiceData('passportDamage', value);
  };

  const handleNext = () => {
    if (selfServiceData.passportDamage) {
      goNext();
    }
  };

  return (
    <StepContainer title="Er dit gamle pas beskadiget?">
      {body.length > 0 && (
        <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>
      )}
      <RadioGroup
        name="passportDamage"
        options={damageChoices}
        value={selfServiceData.passportDamage}
        onChange={handleChange}
        legend="Er dit gamle pas beskadiget?"
        required={true}
      />
      <NavigationButtons
        onBack={goBack}
        onNext={handleNext}
        nextDisabled={!selfServiceData.passportDamage}
      />
    </StepContainer>
  );
};

export default AskPassportDamageStep;
